export default "__VITE_ASSET__DudhfNy5__"